module.exports = __webpack_public_path__ + "img/big-remnants.68d00961.png";